import { render } from "./ReportBeingPrepared.vue?vue&type=template&id=999d0e08&ts=true"
import script from "./ReportBeingPrepared.vue?vue&type=script&lang=ts"
export * from "./ReportBeingPrepared.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__